import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22ibm-mono.ts%22,%22import%22:%22IBM_Plex_Mono%22,%22arguments%22:[{%22display%22:%22swap%22,%22fallback%22:[%22ui-monospace%22,%22SFMono-Regular%22,%22SF%20Mono%22,%22Menlo%22,%22Consolas%22,%22monospace%22],%22subsets%22:[%22latin%22],%22variable%22:%22--font-ibm-mono%22,%22weight%22:[%22400%22,%22500%22,%22600%22,%22700%22]}],%22variableName%22:%22ibmMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'IBM Plex Mono', ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas, monospace",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
